module.exports = __webpack_public_path__ + "static/media/whatsapp-primary-dark.2198ca02.svg";